import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default function setCheckedRadio(elementList, parent) {
  elementList.forEach(function (element, i) {
    element.addEventListener('change', function () {
      elementList.forEach(function (e) {
        e.closest(parent).classList.toggle('o-productofferservice__item--checked', e.checked);
        var elementsToHide = document.querySelectorAll(".js-offer-".concat(e.value));
        if (elementsToHide.length > 0) {
          elementsToHide.forEach(function (element) {
            element.classList.toggle('kl-hidden', !e.checked);
            var haveAttributeAriaHidden = element.getAttribute('aria-hidden');
            if (haveAttributeAriaHidden) {
              element.setAttribute('aria-hidden', "".concat(!e.checked));
            }
          });
        }
      });
    });
  });
  window.onbeforeunload = function () {
    elementList.forEach(function (element, i) {
      element.checked = !(i >= 1);
    });
  };
}